import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {TabsComponent} from './ui-tabs/tabs.component';
import {TabComponent} from './ui-tabs/tab.component';

@NgModule({
  declarations: [TabsComponent, TabComponent],
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  exports: [TabsComponent, TabComponent]
})
export class UiTabsModule {}
